/* eslint-disable no-bitwise */

/**
 * Lightens a hex color by a given percentage
 * @param hex - The hex color to lighten (e.g., "#FF5733")
 * @param percent - The percentage to lighten (default: 40)
 * @returns The lightened hex color
 */
export const lightenColor = (hex: string, percent = 40): string => {
  const num = parseInt(hex.replace('#', ''), 16);
  const amt = Math.round(2.55 * percent);
  const R = Math.min(255, (num >> 16) + amt);
  const G = Math.min(255, ((num >> 8) & 0x00FF) + amt);
  const B = Math.min(255, (num & 0x0000FF) + amt);
  return `#${(0x1000000 + R * 0x10000 + G * 0x100 + B).toString(16).slice(1)}`;
};

/**
 * Default colors for each category icon (original gradient start colors)
 */
export const defaultIconColors: Record<string, { primary: string; secondary: string }> = {
  Bank: { primary: '#1ABCE1', secondary: '#006278' },
  Education: { primary: '#6DBE6D', secondary: '#228B22' },
  Family: { primary: '#C474FF', secondary: '#6A179E' },
  Health: { primary: '#E99A8B', secondary: '#B6387E' },
  Identity: { primary: '#74BBDC', secondary: '#2B6174' },
  Pension: { primary: '#BD63BC', secondary: '#611462' },
  Property: { primary: '#FFA683', secondary: '#CF4200' },
  Subscriptions: { primary: '#32AFE4', secondary: '#0640BC' },
  Tax: { primary: '#EC4A85', secondary: '#8E2C4E' },
  Travel: { primary: '#FDAE41', secondary: '#A15E02' },
  Vehicle: { primary: '#04BFBB', secondary: '#015E5C' },
  Work: { primary: '#94B848', secondary: '#4D7200' },
  Pets: { primary: '#D4A373', secondary: '#85582B' },
  CustomFolder: { primary: '#9333EA', secondary: '#C084FC' },
};

/**
 * Gets the gradient colors for an icon, optionally overridden by a custom color
 * @param iconName - The name of the icon
 * @param customColor - Optional custom color to use instead of default
 * @returns Object with primary and secondary colors for the gradient
 */
export const getIconGradientColors = (
  iconName: string,
  customColor?: string,
): { primary: string; secondary: string } => {
  if (customColor) {
    return {
      primary: customColor,
      secondary: lightenColor(customColor, 20),
    };
  }

  return defaultIconColors[iconName] || defaultIconColors.CustomFolder;
};
